import { useTranslation } from 'react-i18next';

import { CompanyReadModel, useDeleteCompaniesByIdMutation } from '@client/api';
import { Button, Modal, ModalFooter } from '@client/toolkit';
import { DeleteConfirmationModalContent } from '../../../../components/delete-confirmation-modal-content/delete-confirmation-modal-content';

interface CompanyDeleteModalProps {
  company: CompanyReadModel | null;
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

export function CompanyDeleteModal({ company, open, onCancel, onDelete }: CompanyDeleteModalProps) {
  const { t: tCommon } = useTranslation();

  const [deleteCompany, { isLoading: isDeletingCompany }] = useDeleteCompaniesByIdMutation();

  const handleDeleteCompany = async () => {
    if (company?.id == null) return;
    await deleteCompany({ id: company.id });
    onDelete();
  };

  const handleClose = () => {
    if (isDeletingCompany) return;
    onCancel();
  };

  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose} closeDisabled={isDeletingCompany}>
      <DeleteConfirmationModalContent name={company?.name ?? ''} />
      <ModalFooter className="justify-center">
        <Button color="danger" onClick={handleDeleteCompany} progressing={isDeletingCompany}>
          {tCommon('delete')}
        </Button>
        <Button color="primary-dark" onClick={handleClose}>
          {tCommon('cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
